const ITEMS = [
  "Retina",
  "Cataract",
  "Uvea",
  "ROP Screening",
  "Vitreoretinal Surgery",
  "Premium IOLs",
  "Retina Laser",
  "Diabetic Eye Care",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-slate-100 bg-white py-5" aria-hidden="true">
      <div className="flex w-max animate-marquee gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-serif italic text-xl sm:text-2xl text-ink/70 whitespace-nowrap">{item}</span>
            <svg viewBox="0 0 24 24" className="w-4 h-4 text-aqua shrink-0" fill="none" stroke="currentColor" strokeWidth="1.6">
              <path d="M2 12c2.8-4.4 6-6.6 10-6.6S19.2 7.6 22 12c-2.8 4.4-6 6.6-10 6.6S4.8 16.4 2 12z" />
              <circle cx="12" cy="12" r="2.6" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
};
